export default __webpack_public_path__ + "static/media/logo_spence.da739eca.png";